import * as React from 'react';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const RadioEmptyIcon = ({ size = 'xsmall' }: IconProps) => {
    return (
        <svg
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 20 20"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            data-testid="icon-radioEmpty"
        >
            <title>Radio Unselected</title>
            <g id="Setting-Starting-LIneup" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g
                    id="SSLU---Set-DH---Desktop-3"
                    transform="translate(-751.000000, -263.000000)"
                    fill="#FFFFFF"
                    stroke="#9DB2C4"
                >
                    <g id="Control-/-Radio-/-Radio-Unselected-Copy-13" transform="translate(751.000000, 263.000000)">
                        <path
                            d="M10,0.5 C12.6233526,0.5 14.9983526,1.56332372 16.7175144,3.28248558 C18.4366763,5.00164744 19.5,7.37664744 19.5,10 C19.5,12.6233526 18.4366763,14.9983526 16.7175144,16.7175144 C14.9983526,18.4366763 12.6233526,19.5 10,19.5 C7.37664744,19.5 5.00164744,18.4366763 3.28248558,16.7175144 C1.56332372,14.9983526 0.5,12.6233526 0.5,10 C0.5,7.37664744 1.56332372,5.00164744 3.28248558,3.28248558 C5.00164744,1.56332372 7.37664744,0.5 10,0.5 Z"
                            id="Oval-1"
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
};
